<template>
  <div v-editable="blok" class="chart">
    <StoryblokComponent
      v-for="childBlok in blok.left_side"
      :key="childBlok._uid"
      :blok="childBlok"
      class="chart__text"
    />
    <div
      class="chart__bars"
      :class="{ 'chart__bars--reversed': isChartReversed }"
    >
      <span class="chart__bar chart__bar--high" :class="[chartColor]" />
      <span class="chart__bar" :class="[chartColor]" />
    </div>
    <StoryblokComponent
      v-for="childBlok in blok.right_side"
      :key="childBlok._uid"
      :blok="childBlok"
      class="chart__text"
    />
  </div>
</template>

<script lang="ts" setup>
import type { SbChartBarsStoryblok } from '@/types'
interface Props {
  blok: SbChartBarsStoryblok
}
const props = defineProps<Props>()

const chartColor = computed(() => {
  return `bg-${props.blok?.bar_color}`
})
const isChartReversed = computed(() => {
  return props.blok.reversed
})
</script>

<style lang="scss" scoped>
.chart {
  display: flex;
  align-items: flex-end;

  &__bars {
    margin: 0 12px 2px;
    display: flex;
    align-items: flex-end;

    &--reversed {
      flex-direction: row-reverse;
    }
  }

  &__bar {
    margin-right: 6px;
    margin-left: 6px;
    display: inline-block;
    width: 24px;
    height: 54px;
    border-radius: 4px 4px 0 0;

    &--high {
      height: 104px;
    }
  }

  &__text {
    margin-bottom: 0;
  }
}
</style>
